export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT
export const WEBSITE = process.env.REACT_APP_WEBSITE
